/* eslint-disable @typescript-eslint/no-unused-vars */

xplenty.directive('mongoDestinationEditor', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./mongo-destination-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        function ($scope) {
          $scope.onRecordsChange = (records) => {
            $scope.component.column_mappings = records;
          };
        },
      ],
    };
  },
]);
